// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SharedDataViewTabs__container-a101d3 {
  height: 100%;
  overflow: hidden;
}

.SharedDataViewTabs__tabs-cea1d7 {
  padding-top: 8px;
  padding-bottom: 2px;
  padding-inline-start: 24px;
  padding-inline-end: 20px;
  border-bottom: 1px solid var(--base-20);
}

.SharedDataViewTabs__tab-e241a7 {
  margin-inline-start: 16px;
  margin-inline-end: 16px;
}

.SharedDataViewTabs__tab-e241a7:first-child {
  margin-inline-start: 0;
}

.SharedDataViewTabs__tab-title-a899ec {
  font: var(--font-body-2);
  padding-bottom: 8px;
}

.SharedDataViewTabs__tab-underline-c09eed {
  border-width: 3px;
  border-radius: 3px 3px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ShareDataView/SharedDataViewTabs/SharedDataViewTabs.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uCAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,0BAAA;AACF","sourcesContent":[".container {\n  height: 100%;\n  overflow: hidden;\n}\n\n.tabs {\n  padding-top: 8px;\n  padding-bottom: 2px;\n  padding-inline-start: 24px;\n  padding-inline-end: 20px;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.tab {\n  margin-inline-start: 16px;\n  margin-inline-end: 16px;\n}\n\n.tab:first-child {\n  margin-inline-start: 0;\n}\n\n.tab-title {\n  font: var(--font-body-2);\n  padding-bottom: 8px;\n}\n\n.tab-underline {\n  border-width: 3px;\n  border-radius: 3px 3px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SharedDataViewTabs__container-a101d3`,
	"tabs": `SharedDataViewTabs__tabs-cea1d7`,
	"tab": `SharedDataViewTabs__tab-e241a7`,
	"tab-title": `SharedDataViewTabs__tab-title-a899ec`,
	"tabTitle": `SharedDataViewTabs__tab-title-a899ec`,
	"tab-underline": `SharedDataViewTabs__tab-underline-c09eed`,
	"tabUnderline": `SharedDataViewTabs__tab-underline-c09eed`
};
module.exports = ___CSS_LOADER_EXPORT___;
